import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { z } from 'zod';

import { ResetPasswordForm } from './-components/ResetPassword';

export const Route = createFileRoute('/(auth)/reset-password/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) =>
    z
      .object({
        email: z.string(),
      })
      .parse(search),
});

function RouteComponent() {
  const router = useRouter();
  const { formatMessage } = useIntl();
  const { email } = Route.useSearch();

  const parsedEmail = decodeURIComponent(email);

  return (
    <ResetPasswordForm
      onPasswordReset={async () => {
        router.navigate({
          to: '/',
        });
      }}
      email={parsedEmail}
      title={formatMessage({
        id: 'auth.resetPasswordOnForgotPassword.title',
      })}
    />
  );
}
